import {
  CLEAR_STATE,
  clearToken,
  clearState,
  clearAuthentication,
  validateGoogleAuth,
  validateWhitelistedEmail,
} from "containers/Auth";
import { clearSupportUser } from "common/utils";
import { push } from "react-router-redux";
import jwtDecode from "jwt-decode";

import { INVALID_EMAIL_ERROR_MSG } from "constants/constants";

// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_REQUEST = "A.LOGIN_REQUEST";
export const LOGIN_SUCCESS = "A.LOGIN_SUCCESS";
export const LOGIN_FAILED = "A.LOGIN_FAILED";
export const LOGIN_CANCELLED = "A.LOGIN_CANCELLED";
export const UPDATE_LOGIN_ERROR = "A.UPDATE_LOGIN_ERROR";
export const LOGOUT = "A.LOGOUT";

// ------------------------------------
// Actions
// ------------------------------------
export function requestLogin() {
  return {
    type: LOGIN_REQUEST,
  };
}
export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  };
}
export function loginFailed() {
  return {
    type: LOGIN_FAILED,
  };
}
export function loginCancelled() {
  return {
    type: LOGIN_CANCELLED,
  };
}
export function updateLoginError(errorMsg) {
  return {
    type: UPDATE_LOGIN_ERROR,
    payload: errorMsg,
  };
}
export function logout() {
  return {
    type: LOGOUT,
  };
}

export function handleLogin(token) {
  return (dispatch, getState) => {
    /* Since handleLogin is called as callback from
      react-google-login this redux request action
      will be delayed */
    dispatch(requestLogin());

    // if (GoogleAuth.error) {
    //   dispatch(loginCancelled());
    //   return;
    // }

    dispatch(validateGoogleAuth(token))
      .then((res) => {
        const email = token ? jwtDecode(token).email : '' ;

        dispatch(validateWhitelistedEmail(email)).then((emailIsValid) => {
          if (!emailIsValid) {
            dispatch(updateLoginError(INVALID_EMAIL_ERROR_MSG));
            /* eslint-disable no-undef */
            // const gAuth = window.gapi.auth2.getAuthInstance();
            // gAuth.disconnect();
            /* eslint-enable no-undef */
            dispatch(loginFailed());
            return;
          }

          dispatch(updateLoginError());
          dispatch(loginSuccess());
          dispatch(push("/"));
        });
        dispatch(updateLoginError());
        dispatch(loginSuccess());
        dispatch(push("/"));
      })
      .catch((err) => {
        dispatch(loginFailed());
      });
  };
}

export function handleLogout(e, msg = "") {
  return (dispatch, getState) => {
    dispatch(logout());
    dispatch(push("/login"));
    clearToken();
    clearSupportUser();
    dispatch(clearState());
    dispatch(clearAuthentication());
    msg.length > 0 && dispatch(updateLoginError(msg));
  };
}

const initialState = {
  errorMsg: "",
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CLEAR_STATE]: (state, action) => {
    return { initialState };
  },
  [UPDATE_LOGIN_ERROR]: (state, action) => {
    return { ...state, errorMsg: action.payload };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function appReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Login/module.js